import type { WithdrawResponse } from '@mobi/account/Areas/Withdraw/Utils/types'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackWithdrawalPercentage = (withdrawalResponse: WithdrawResponse) => {
  const { balance, withdrawalAmount } = withdrawalResponse
  const fraction = withdrawalAmount / (balance + withdrawalAmount)
  const percentage = Math.floor(fraction * 100)

  trackEvent(keys.withdrawal, { percentage })
}
